import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../components/HeaderCustom";
import { Alert, Backdrop, CircularProgress, Snackbar } from "@mui/material";
import SkeletonLoading from "../../../components/SkeletonLoading";
import '../../../styles/AppCss.css'
import { useLocation, useNavigate } from "react-router-dom";
import { getLocalesFiltrarPorNombre, postUpdateCupon } from "../../../api/ApiService";
import EditarCuponComponents from "./components/EditarCuponComponents";
import dayjs from 'dayjs';

function EditarCuponPage() {
    const [cargando, setCargando] = useState(false);

    const [locales, setLocales] = useState([]);
    const [localSearch, setLocalSearch] = useState('');
    const [localSelected, setLocalSelected] = useState(null);

    const [monedasSearch, setMonedasSearch] = useState('');
    const [monedasSelected, setMonedasSelected] = useState(null);

    const [motivoRechazoSearch, setMotivoRechazoSearch] = useState('');
    const [motivoRechazoSelected, setMotivoRechazoSelected] = useState(null);

    const [observacionAdicional, setObservacionAdicional] = useState('');

    const [nombreUsuario, setNombreUsuario] = useState('');
    const [documentoCliente, setDocumentoCliente] = useState('');
    const [nroFactura, setNroFactura] = useState('');
    const [nrotimbrado, setNroTimbrado] = useState('');
    const [monto, setMonto] = useState('');
    const [fecha, setFecha] = useState(null);
    const [fechaBackend, setFechaBackend] = useState('');
    const [rechazar, setRechazar] = useState(false);
    const [imagen, setImagen] = useState(null);

    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [loadingCargando, setLoadingCargando] = useState(false);


    const stateToken = useSelector(state => state.reducerGlobal.token);


    const localizacion = useLocation();
    const { state } = localizacion;
    // console.log("state", state);

    const navigate = useNavigate();


    useEffect(() => {
        if (stateToken) {
            if (state) {
                handleListarLocales(state?.data?.local_nombre);
            }
        }
    }, [state, stateToken]);

    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (localSearch.length > 2) {
                setLoadingCargando(true);
                handleListarLocales(localSearch);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, localSearch]);



    useEffect(() => {
        // setCargando(true);
        if (state) {
            setCargando(true);

            setNombreUsuario(state?.data?.usuario_full_name);
            setDocumentoCliente(state?.data?.ruc_cliente_factura === null ? '' : state?.data?.ruc_cliente_factura);
            setNroFactura(state?.data?.nro_factura === null ? '' : state?.data?.nro_factura);
            setNroTimbrado(state?.data?.timbrado === null ? '' : state?.data?.timbrado);
            setFecha(dayjs(state?.data?.fecha));
            setFechaBackend(state?.data?.fecha);
            setLocalSelected(state?.data?.local);
            setImagen(state?.data?.imagen);

            //eliminar los puntos decimales en monto_format
            setMonto(state?.data?.monto_format.replace(/\./g, ''));

            //pasar a minuscula y comparar
            if (state?.data?.moneda?.toLowerCase() === "guaranies") {
                console.log("Guaranies");
                setMonedasSelected({ label: 'Guaranies', value: "Guaranies", id: 1 });
            } else if (state?.data?.moneda?.toLowerCase() === 'dolares') {
                setMonedasSelected({ label: 'Dolares', value: "Dolares", id: 2 });
            }
        }
    }, [state]);




    //=================================================================================================funcion para listar las categorias
    const handleListarLocales = (busqueda) => {

        getLocalesFiltrarPorNombre(busqueda, stateToken?.access_token)
            .then((response) => {
                // console.log("response-getLocalesFiltrarPorNombre", response);
                setLoadingCargando(false);
                if (response.data.length > 0) {
                    setLocales(response.data);

                    setCargando(true);
                } else {
                    setLocales([]);
                    setCargando(true);
                }
            })
            .catch((error) => {
                console.log("error-getLocalesFiltrarPorNombre", error);
                setLoadingCargando(false);
                setLocales([]);
                setCargando(true);
            });
    };




    //=========================================================cerrar modal de alerta
    const handleClose = () => {
        setOpen(false);
    };


    //=========================================================funcion para guardar
    const handleGuardar = () => {

        //crear un formtdata para enviar la imagen, titulo,descripcion,vigencia_desde, vigencia_hasta
        //fecha_evento_desde, fecha_evento_hasta, ubicacion
        let body = {
            local_id: localSelected?.id,
            ruc_cliente_factura: documentoCliente,
            monto: monto,
            fecha: fechaBackend,
            moneda: monedasSelected?.label,
            nro_factura: nroFactura,
            timbrado: nrotimbrado,
            estado: rechazar === true ? 'rechazado' : 'aprobado',
            procesado_por: 'usuario_sistema',
            user_id: stateToken?.data?.id,
            motivo_rechazo: rechazar === true ? motivoRechazoSelected?.label === 'Otros' ? observacionAdicional : motivoRechazoSelected?.label : 'no corresponde',
        }



        //validar campos que no esten vacios
        if (documentoCliente.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo documento cliente es obligatorio');

        } else if (localSelected === null) {

            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo local es obligatorio');


        } else if (nroFactura.trim() === '') {

            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo nro factura es obligatorio');


        } else if (nrotimbrado === null) {

            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo nro timbrado es obligatorio');


        } else if (monto.trim() === '') {

            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo monto es obligatorio');


        } else if (monedasSelected === null) {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo moneda es obligatorio');

        } else if (fecha === null) {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo fecha es obligatorio');
        } else if (rechazar === true && motivoRechazoSelected === null) {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo motivo de rechazo es obligatorio');

        } else if (rechazar === true && motivoRechazoSelected?.label === 'Otros' && observacionAdicional.trim() === '') {
            setOpen(true);
            setSeverity('warning');
            setMensaje('El campo observacion adicional es obligatorio');
        } else {

            setLoadingCargando(true);
            console.log("body", body);


            handleUpdateApi(body);
        }
    };


    //=============================================api de crear evento
    const handleUpdateApi = (body) => {

        postUpdateCupon(body, state?.data?.id, stateToken?.access_token)
            .then((response) => {
                console.log("response-postUpdateCupon", response);
                setLoadingCargando(false);

                setTimeout(() => {
                    setOpen(true);
                    setSeverity('success');
                    setMensaje('Guardado con exito');

                    setTimeout(() => {
                        navigate('/app/admin/cupones');
                    }, 1500);

                }, 1000);


            })
            .catch((error) => {
                console.log("error-postUpdateCupon", error);
                setLoadingCargando(false);
                setOpen(true);
                setSeverity('error');
                setMensaje('Error al guardar');
                setTimeout(() => {
                    setOpen(false);
                }, 2000);
            });
    };





    //=========================================================funcion para seleccionar locales
    const handleLocalSelected = (value) => {
        console.log("value-handleLocalSelected: ", value);
        setLocalSelected(value);
    };

    //=========================================================funcion para buscar locales
    const handleLocalSearch = (value) => {
        console.log("value-handleLocalSearch: ", value);
        setLocalSearch(value);

        if (value.length > 0) {
            handleListarLocales(value);
        }


    };


    //=============================================funcion para seleccionar la fecha inicio del evento
    const handleFechaSelected = (event) => {
        // console.log("event", event);
        setFecha(event);

        //obtener la fecha en formato YYYY-MM-DD
        if (event) {
            // Formatear la fecha y hora en formato local (YYYY-MM-DD HH:mm:ss)
            // let fecha = dayjs(event).format('YYYY/MM/DD HH:mm:ss');
            let fecha = dayjs(event).format('YYYY/MM/DD');
            console.log("Fecha formateada:", fecha); // Ejemplo: 2025-04-17 11:25:00

            // Establecer la fecha en el backend
            setFechaBackend(fecha);
        } else {
            console.error("El evento no contiene una fecha válida.");
        }
    };







    //=========================================================funcion para buscar monedas
    const handleMonedasSearch = (value) => {
        console.log("value-handleMonedasSearch: ", value);
        setMonedasSearch(value);
    };


    //=============================================funcion para seleccionar la moneda
    const handleMonedasSelected = (event) => {
        // console.log("event", event);
        setMonedasSelected(event);
    };


    //=========================================================funcion para buscar motivo de rechazo       
    const handleMotivoRechazoSearch = (value) => {
        console.log("value-handleMotivoReachazoSearch: ", value);
        setMotivoRechazoSearch(value);
    };


    //=============================================funcion para seleccionar motivo de rechazo
    const handleMotivoRechazoSelected = (event) => {
        // console.log("event", event);
        setMotivoRechazoSelected(event);
    };






    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-4 sm:p-6">
                <div className="max-w-7xl mx-auto">
                    <div className="mb-6">
                        <h1 className="text-2xl font-bold text-gray-800 mb-1">Procesar Factura</h1>
                    </div>

                    {cargando ? (
                        <div className="bg-white rounded-xl shadow-xl overflow-hidden p-6">
                            <EditarCuponComponents
                                nombreUsuario={nombreUsuario}

                                documentoCliente={documentoCliente}
                                setDocumentoCliente={setDocumentoCliente}

                                nroFactura={nroFactura}
                                setNroFactura={setNroFactura}

                                nrotimbrado={nrotimbrado}
                                setNroTimbrado={setNroTimbrado}

                                monto={monto}
                                setMonto={setMonto}

                                imagen={imagen}

                                fecha={fecha}
                                handleFechaSelected={handleFechaSelected}

                                rechazar={rechazar}
                                setRechazar={setRechazar}

                                locales={locales}
                                localSelected={localSelected}
                                handleLocalSelected={handleLocalSelected}
                                handleLocalSearch={handleLocalSearch}

                                monedasSelected={monedasSelected}
                                handleMonedasSearch={handleMonedasSearch}
                                handleMonedasSelected={handleMonedasSelected}

                                motivoRechazoSelected={motivoRechazoSelected}
                                handleMotivoRechazoSearch={handleMotivoRechazoSearch}
                                handleMotivoRechazoSelected={handleMotivoRechazoSelected}

                                observacionAdicional={observacionAdicional}
                                setObservacionAdicional={setObservacionAdicional}

                                handleGuardar={handleGuardar}
                            />
                        </div>
                    ) :
                        (
                            <div className="bg-white rounded-xl shadow-md p-8">
                                <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                                <div className="space-y-4">
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-10 bg-gray-200 rounded animate-pulse" />
                                    <div className="h-24 bg-gray-200 rounded animate-pulse" />
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>

            <Backdrop open={loadingCargando} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={open} autoHideDuration={2000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={severity} elevation={6} variant="filled" >
                    {mensaje}
                </Alert>
            </Snackbar>
        </HeaderCustom>
    );
}

export default EditarCuponPage;